<template>
  <div>
    <el-form :inline="true" :model="form" ref="form">
      <el-form-item label="服务编号" prop="serviceNo">
        <el-input v-model="form.serviceNo" placeholder="服务编号"></el-input>
      </el-form-item>
      <el-form-item label="出库编号" prop="outBillNo">
        <el-input v-model="form.outBillNo" placeholder="出库编号"></el-input>
      </el-form-item>
      <el-form-item label="机构名称" prop="referName">
        <el-input v-model="form.referName" placeholder="机构名称"></el-input>
      </el-form-item>
      <el-form-item label="服务状态" prop="status">
        <el-select v-model="form.status" placeholder="服务状态">
          <el-option label="待开始" value="0"></el-option>
          <el-option label="进行中" value="1"></el-option>
          <el-option label="已结束" value="2"></el-option>
          <el-option label="作废" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始时间" prop="startTime">
        <el-date-picker
          type="date"
          placeholder="开始时间"
          v-model="form.startTime"
          style="width: 100%"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间" prop="endTime">
        <el-date-picker
          type="date"
          placeholder="结束时间"
          v-model="form.endTime"
          style="width: 100%"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="CRM订单号" prop="crm">
        <el-input v-model="form.user" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="款项是否支付" prop="payState">
        <el-select v-model="form.payState" placeholder="请选择">
          <el-option label="未支付" value="0"></el-option>
          <el-option label="已支付" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch('form')">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="searchReset('form')">重置</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="handleAdd">新增</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="data" border stripe style="width: 100%">
      <el-table-column prop="serviceNo" label="服务编号"> </el-table-column>
      <el-table-column prop="outBillNo" label="出库编号"> </el-table-column>
      <el-table-column prop="referName" label="机构名称"> </el-table-column>
      <el-table-column prop="startTime" label="开始时间"> </el-table-column>
      <el-table-column prop="endTime" label="结束时间"> </el-table-column>
      <el-table-column prop="crm" label="CRM订单号"> </el-table-column>
      <el-table-column prop="payState" label="款项是否支付">
        <template slot-scope="scope">
          {{ scope.row.payState == 0 ? "未支付" :  scope.row.payState == 1 ? "已支付" : '' }}
        </template>
      </el-table-column>
      <el-table-column prop="payTime" label="预期付款时间"> </el-table-column>
      <el-table-column prop="statusName" label="服务状态"> </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            :disabled="scope.row.status == 2 || scope.row.status == 3"
            @click="cancel(scope.row)"
            >作废</el-button
          >
          <el-button type="text" size="small" @click="Edit(scope.row)"
            >编辑</el-button
          >
          <el-button type="text" size="small" @click="onRecord(scope.row)"
            >修改记录</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>
    <el-dialog
      :title="title"
      center
      :visible.sync="addVisible"
      width="38%"
      @closed="handleClose"
    >
      <el-form
        :model="addForm"
        label-width="120px"
        :rules="rules"
        ref="addForm"
      >
        <el-form-item label="出库编号" prop="outBillNo">
          <el-select
            v-model="addForm.outBillNo"
            placeholder="请选择入出库编号"
            :disabled="disabled"
          >
            <el-option
              v-for="val in outBillNoData"
              :key="val"
              :label="val"
              :value="val"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="使用状态" prop="useState">
          <el-select v-model="addForm.useState" placeholder="请选择">
            <el-option value="1" label="正式使用"></el-option>
            <el-option value="2" label="试用"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间" prop="startTime">
          <el-date-picker
            type="date"
            placeholder="开始时间"
            v-model="addForm.startTime"
            value-format="yyyy-MM-dd HH:ss:mm"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-date-picker
            type="date"
            placeholder="开始时间"
            v-model="addForm.endTime"
            value-format="yyyy-MM-dd HH:ss:mm"
          ></el-date-picker>
        </el-form-item>
        <template v-if="addForm.useState === '1'">
          <el-form-item label="CRM订单号" prop="crm">
            <el-input
              placeholder="请输入CRM订单号"
              v-model="addForm.crm"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否全部付款" prop="payState">
            <el-radio-group v-model="addForm.payState">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="addForm.payState === '0'">
            <el-form-item label="预期付款时间" prop="payTime">
              <el-date-picker
                type="date"
                placeholder="开始时间"
                v-model="addForm.payTime"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </template>
        </template>
        <el-form-item>
          <el-button type="primary" @click="submitForm('addForm')"
            >提交</el-button
          >
          <el-button @click="resetForm('addForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="修改记录" :visible.sync="open" @close="closeDailog">
      <el-row class="search-add" :gutter="10">
        <el-col :span="24"> 服务编号：{{ editData.serviceNo }} </el-col>
      </el-row>
      <el-table :data="recordData" border stripe style="width: 100%">
        <el-table-column type="index" width="50" label="序号">
        </el-table-column>
        <el-table-column property="changeTime" label="修改时间" width="120">
        </el-table-column>
        <el-table-column prop="message" label="修改内容"> </el-table-column>
      </el-table>
      <div class="tableDel-Page">
        <el-pagination
          :current-page="recordPagin.pageNum"
          :page-size="recordPagin.pageSize"
          layout="prev, pager, next"
          :total="recordPagin.total"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDailog">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
export default {
  name: "admin",
  data() {
    return {
      addVisible: false,
      title: "新建",
      termVersion: "",
      devId: "",
      data: [],
      form: {},
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      addForm: {
        outBillNo: "",
        useState: "",
        payState: "1",
        startTime: "",
        endTime: "",
        crm: "",
        payTime: "",
      },
      editData: {},
      rules: {
        outBillNo: [{ required: true, message: "请输入", trigger: "blur" }],
        useState: [{ required: true, message: "请选择", trigger: "blur" }],
        startTime: [{ required: true, message: "请选择", trigger: "blur" }],
        endTime: [{ required: true, message: "请选择", trigger: "blur" }],
        crm: [{ required: true, message: "请输入", trigger: "blur" }],
        payState: [{ required: true, message: "请选择", trigger: "blur" }],
        payTime: [{ required: true, message: "请选择", trigger: "blur" }],
      },
      disabled: false,
      open: false,
      recordData: [],
      recordPagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      outBillNoData: [],
    };
  },
  mounted() {
    this.$http.post("/manage/outBill/listBillNo", {}).then((res) => {
      this.outBillNoData = res["data"]["data"];
    });
  },
  methods: {
    onRecord(data) {
      console.log(data);
      this.open = true;
      this.editData = JSON.parse(JSON.stringify(data));
      this.recordList();
    },
    recordList() {
      const params = {
        pageNum: this.recordPagin.pageNum,
        pageSize: this.recordPagin.pageSize,
        serviceId: this.editData.id,
      };
      this.$http
        .post("/manage/outService/listPageEditLog", params)
        .then((res) => {
          this.recordData = res["data"]["data"]["records"];
          this.recordPagin.total = res["data"]["data"]["total"];
        });
    },
    handleCurrentChange(val) {
      this.recordPagin.pageNum = val;
      this.recordList();
    },
    closeDailog() {
      this.open = false;
    },
    handleAdd() {
      this.title = "新建";
      this.addVisible = true;
      this.disabled = false;
    },
    getList() {
      //数据绑定
      let params = {
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
        ...this.form,
      };

      this.$http.post("/manage/outService/listPage", params).then((results) => {
        this.data = results["data"]["data"]["records"];
        this.pagin.total = results["data"]["data"]["total"];
      });
    },
    Edit(data) {
      this.disabled = true;
      this.addVisible = true;
      this.title = "编辑";
      console.log(data, "edit");
      data.useState = data.useState + "";
      data.payState = data.payState + "";
      this.addForm = JSON.parse(JSON.stringify(data));
    },
    handleClose() {
      this.addVisible = false;
      this.addForm = {};
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.addForm.useState === '2') {
             this.addForm.crm = "";
             this.addForm.payState ="";
             this.addForm.payTime="";
          }
          this.$http
            .post(
              `${
                this.disabled
                  ? "/manage/outService/edit"
                  : "/manage/outService/add"
              }`,
              this.addForm
            )
            .then((res) => {
              if (res.data.code === 0) {
                this.getList();
                this.$refs[formName].resetFields();
                this.addVisible = false;
                this.$message({
                  message: `${this.disabled ? "编辑" : "保存"}成功`,
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.data.message,
                  type: "error",
                });
              }
            });
        }
      });
    },
    resetForm(formName) {
      this.addVisible = false;
      this.addForm = {};
      this.$refs[formName].resetFields();
    },
    onSearch() {
      this.pagin.pageNum = 1;
      this.getList();
    },
    searchReset(formName) {
      this.$refs[formName].resetFields();
      this.pagin.pageNum = 1;
      this.getList();
    },
    cancel(data) {
      if (confirm("确认要作废吗？")) {
        if (!data.id) {
          return;
        }
        this.$http
          .post("/manage/outService/cancel", { id: data.id })
          .then((res) => {
            if (res.data.code === 0) {
              this.getList();
              this.$message({
                message: "操作成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.message,
                type: "error",
              });
            }
          });
      }
    },
  },
  components: { Pagination },
};
</script>
